import { Row, Col, Button, Alert } from "antd"
import { Header } from "../Header"

/**
 * @param {object} [props]
 * @param {Error} [props.error] — set when used as react-error-boundary FallbackComponent
 * @param {() => void} [props.resetErrorBoundary]
 */
export function Error({ error, resetErrorBoundary }) {

      const isCrash = Boolean(error)

      if (isCrash) {
            console.error(error)
      }

      return (

            <>

                  <Header />

                  <div id="content" className="section">

                        <Row justify="center">

                              <Col span={21}>

                                    <Row className="pagetitle">
                                          <Col>
                                                <h1>Whoops, something went wrong.</h1>
                                                <p>
                                                      {isCrash
                                                            ? "The app hit a runtime error. Details are below."
                                                            : "The page you request cannot be found"}
                                                </p>
                                                {isCrash ? (
                                                      <>
                                                            <Alert
                                                                  style={{ marginTop: 16, textAlign: "left" }}
                                                                  type="error"
                                                                  message={error.message}
                                                                  description={
                                                                        <pre
                                                                              style={{
                                                                                    margin: 0,
                                                                                    whiteSpace: "pre-wrap",
                                                                                    wordBreak: "break-word",
                                                                                    fontSize: 12,
                                                                                    maxHeight: 320,
                                                                                    overflow: "auto"
                                                                              }}
                                                                        >
                                                                              {error.stack || "(no stack)"}
                                                                        </pre>
                                                                  }
                                                            />
                                                            {typeof resetErrorBoundary === "function" ? (
                                                                  <Button type="primary" style={{ marginTop: 16 }} onClick={resetErrorBoundary}>
                                                                        Try again
                                                                  </Button>
                                                            ) : null}
                                                      </>
                                                ) : null}
                                          </Col>
                                    </Row>

                              </Col>

                        </Row>

                  </div>


            </>



      )


}
